import React from "react";
import img from "../../constant";
import { BiLogOut } from "react-icons/bi";
import { logout_user } from "../../services/api/auth";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../screens/auth/hooks/useAuth";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const {
    isEmail,
    isOrganizationName,
    isName: firstName,
    isLastName: lastName,
  } = useAuth();
  // const { organizationData } = useOrganizationData();
  const getInitials = (): string => {
    if (!firstName) return "NA";

    const firstInitial = firstName?.charAt(0)?.toUpperCase() ?? "";
    const lastInitial = lastName?.charAt(0)?.toUpperCase() ?? "";

    return firstInitial + lastInitial;
  };

  return (
    <div className="w-full bg-white border-b border-[#E4E7EC]">
      <nav className="flex justify-between items-center py-4 navbar max-w-[1096px] mx-auto px-3">
        {/* <Link href="/clients">Client New</Link> */}
        <div className="mr-1"></div>
        {/* <SearchInput
          className="w-full"
          name="search"
          // value={search}
          placeholder="Search here..."
          icon={<BiSearchAlt size={18} color="#243677" />}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            // const { value } = e.target;
            // dispatch(setSearch(value));
          }}
        /> */}
        <div className="flex items-center">
          <div className="flex items-center cursor-pointer">
            <div className="w-[30px] h-[30px] rounded-full bg-[#CDD8FE] flex items-center justify-center text-black text-[16px] mx-2">
              {getInitials()}
            </div>
            <div className="text-14 md:block hidden">
              <p className="text-[14px] leading-4">
                Hi {isOrganizationName || "User"}
              </p>
              <p className="text-[14px] leading-4">{isEmail || "NA"}</p>
            </div>
          </div>
          <div
            onClick={() => logout_user(navigate)}
            className="mx-2 cursor-pointer"
          >
            <BiLogOut size={20} />
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
